import { InventoryFee, Venue } from 'types/model'
import { SubtotalLineItem } from './subtotal-line-item'
import { formatPercent } from '@utils/strings'

export function SubtotalFeeLines({
  venue,
  processingValue,
  processingPercent,
  tipValue,
  tipPercent,
  customFees,
  userPaysProcessing = true,
  taxValue,
  taxPercent,
}: {
  venue: Venue
  processingValue?: number
  customFees: InventoryFee[]
  userPaysProcessing?: boolean
  tipValue: number
  taxValue: number
  processingPercent?: number
  tipPercent: number
  taxPercent: number
}) {
  return (
    <div className='w-full space-y-1'>
      {customFees
        ?.filter((fee) => fee.feeType !== 'PROCESSING')
        .map((fee) =>
          !fee.value ? null : (
            <SubtotalLineItem
              name={`${fee.name}${fee.type === 'PERCENT' ? ` (${formatPercent(fee.amount)})` : ''}`}
              key={`${fee.name}`}
              total={fee.value}
              currency={venue.currencyCode}
              languageCode={venue.languageCode}
            />
          )
        )}
      {!tipValue ? null : (
        <SubtotalLineItem
          name={`Service Charge (${formatPercent(tipPercent)})`}
          total={tipValue}
          currency={venue.currencyCode}
          languageCode={venue.languageCode}
        />
      )}
      {!taxValue ? null : (
        <SubtotalLineItem
          name={`Tax (${formatPercent(taxPercent)})`}
          total={taxValue}
          currency={venue.currencyCode}
          languageCode={venue.languageCode}
        />
      )}
      {!processingValue || !userPaysProcessing ? null : (
        <SubtotalLineItem
          currency={venue.currencyCode}
          languageCode={venue.languageCode}
          name={`Processing Fee ${
            !!processingPercent ? `(${formatPercent(processingPercent)})` : ''
          }`}
          total={processingValue}
        />
      )}
    </div>
  )
}
